import { useEffect, useState } from 'react';
import axios from 'axios';
import OpenandCloseModal from '../TradeCurrency/OpenandCloseModal';
import { formatAmount, formatDateStrToDate, getToken } from '../utils';
import { useSearchParams } from 'react-router-dom';

export function useHistortyData() {
  const [searchParams] = useSearchParams();

  const [transactionHistoryDetails, setTransactionHistoryDetails] =
    useState(null);

  const { token: userToken } = getToken();

  const [isLoading, setIsLoading] = useState(false);
  const [transactionHistory, setTransactionHistory] = useState([]);

  const transactionTypeId = !searchParams.get('transaction_type_id')
    ? ''
    : searchParams.get('transaction_type_id');

  const currencyId = !searchParams.get('currency_id')
    ? ''
    : searchParams.get('currency_id');

  useEffect(() => {
    const params = `transaction_type_id=${transactionTypeId}&currency_id=${currencyId}`;

    setIsLoading(true);
    const transactioHistory = async () => {
      try {
        const response = await axios.post(
          `${
            process.env.REACT_APP_BASE_URL
          }/cx-transaction/filter-my-transactions-history?${
            !!currencyId || !!transactionTypeId ? params : ''
          } `,
          {},
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        setTransactionHistory(response.data);
      } catch (error) {
        console.log(error, 'error in lv account');
      } finally {
        setIsLoading(false);
      }
    };

    transactioHistory();
  }, [currencyId, transactionTypeId, userToken]);

  // const currentTransactionId = searchParams.get('transaction_type_id') || '';
  // const currentCurrencyId = searchParams.get('currency_id') || '';

  // function getCurrentCurrency(currencyId, transactionId) {
  //   searchParams.set('currency_id', currencyId);
  //   searchParams.set('transaction_type_id', transactionId);

  //   setSearchParams(searchParams);
  // }

  const { handleOpenandCloseModal, openModal } = OpenandCloseModal();

  const historyDataArray = transactionHistory?.map((data) => {
    const trx_type = data?.transaction_type;
    return {
      date: `${formatDateStrToDate(data?.created_at)}`,
      transaction_type: (
        <span
          className={`py-[2px] px-4 rounded ${
            trx_type?.id === 1
              ? 'bg-green-500/20 text-green-500'
              : trx_type?.id === 2
              ? 'bg-red-500/20 text-red-500'
              : null
          }`}
        >
          {trx_type?.name}
        </span>
      ),
      status: (
        <span
          className={`inline-block py-[2px] px-4 rounded w-[6rem] ${
            data?.transaction_status?.name === 'Completed'
              ? 'bg-green-500/20 text-green-500'
              : data?.transaction_status?.name === 'Expired'
              ? 'bg-yellow-500/20 text-yellow-500'
              : 'bg-red-500/20 text-red-500'
          }`}
        >
          {data?.transaction_status?.name}
        </span>
      ),
      amount: !!data?.payment
        ? `${formatAmount(data?.payment?.amount)} ${
            data?.quote_currency?.symbol
          }`
        : `${formatAmount(data?.amount)} ${data?.quote_currency?.symbol}`,
      rate: !!data?.payment
        ? `${formatAmount(data?.payment?.rate)} ${data?.base_currency?.symbol}`
        : `${formatAmount(data?.rate)} ${data?.base_currency?.symbol}`,
      total: !!data?.payment
        ? `${formatAmount(data?.payment?.total)} ${data?.base_currency?.symbol}`
        : `${formatAmount(data?.amount * data?.rate)} ${
            data?.base_currency?.symbol
          }`,
      payment: data?.transaction_method?.name,
      action: (
        <button
          className='py-1.5 bg-b-mc h-fit text-p-wh rounded text-xs px-4 disabled:bg-p-bk/5 hover:bg-b-mc/75 focus:bg-b-mc/80 w-[6rem]'
          onClick={() => handleGetIdandShowDetails(data?.id)}
          // disabled={disableButton}
        >
          {data?.transaction_status?.name === 'Expired'
            ? 'Edit'
            : 'See details'}
        </button>
      ),
    };
  });

  const handleGetIdandShowDetails = (id) => {
    const filterHistory = transactionHistory?.find((history) => {
      return history?.id === id;
    });
    setTransactionHistoryDetails(filterHistory);

    if (filterHistory.transaction_status.name === 'Expired') {
      handleOpenandCloseModal('transactionEditHistoryDetails');
    } else {
      handleOpenandCloseModal('transactionHistoryDetails');
    }
  };
  // console.log(transactionHistory, historyDataArray, transactionHistoryDetails);

  return {
    historyDataArray,
    transactionHistoryDetails,
    transactionHistory,
    handleOpenandCloseModal,
    openModal,
    isLoading,
  };
}
